// extracted by mini-css-extract-plugin
export default {"wrap":"uXiLJ","accumulator":"nyVbY","accum":"Qv7AT","extended":"mh3J1","low":"wVxtu","gift":"ag5Cd","close":"cnpFp","full-width":"kwaGa","inline":"lIfRl"};